import { AnyFieldApi } from '@tanstack/react-form'
import React, { useEffect, useId, useRef } from 'react'

import { InputErrors, InputGroup, InputGroupBase, InputGroupInput, InputGroupLabel, metaToFieldState } from '@Components/Input'
import { useTranslation } from '@Globals/Translations'

import styles from './GiftCard.module.scss'

export const GiftCardCustomAmount = ({ field }: { field: AnyFieldApi }) => {
  const { t } = useTranslation()
  const id = useId()

  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (inputRef.current) {
      // preventScroll: this can mount while the drawer is still animating in (reopen
      // with a custom amount selected) — a plain focus() scrolls the drawer viewport
      // toward the still-off-screen input and leaves the drawer visually shifted.
      // The scrollIntoView below reveals the field vertically inside the drawer body
      // instead; block 'nearest' scrolls minimally and is a no-op when already visible.
      inputRef.current.focus({ preventScroll: true })
      inputRef.current.scrollIntoView({ block: 'nearest' })
    }
  }, [])

  return (
    <div className={styles.customAmount}>
      <p>{t('giftcard:GIFT_CARD_CUSTOM_AMOUNT_HEADER', 'Please enter your amount')}</p>
      <div>
        <InputGroup state={metaToFieldState(field.state.meta, field.state.value)}>
          <InputGroupBase>
            <InputGroupLabel htmlFor={`${field.name}-${id}`}>
              {t('giftcard:GIFT_CARD_CUSTOM_AMOUNT_LABEL', 'Enter amount')}
            </InputGroupLabel>
            <InputGroupInput
              id={`${field.name}-${id}`}
              inputMode="numeric"
              name={field.name}
              onBlur={field.handleBlur}
              onChange={e => field.handleChange(e.target.value.replace(/\D/g, ''))}
              ref={inputRef}
              type="text"
              value={field.state.value}
            />
          </InputGroupBase>
        </InputGroup>
        <InputErrors
          errors={field.state.meta.errors}
          isTouched={field.state.meta.isTouched}
          isValid={field.state.meta.isValid}
        />
      </div>
    </div>
  )
}
